module.exports = __webpack_public_path__ + "static/media/pyrexx_logo.54ccf324.svg";